import { render, staticRenderFns } from "./SalesforceLogin.vue?vue&type=template&id=69125cdc&scoped=true&"
import script from "./SalesforceLogin.vue?vue&type=script&lang=js&"
export * from "./SalesforceLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69125cdc",
  null
  
)

export default component.exports